(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hover-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('.product-hover-cards__img-wrap').forEach(function (item) {
      item.addEventListener('click', function () {
        var isFlipped = item.classList.contains('is-flipped');
        document.querySelectorAll('.product-hover-cards__img-wrap.is-flipped').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-flipped');
        });
        item.classList.toggle('is-flipped', !isFlipped);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
